function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach((item) =&gt; {
    if (typeof item === 'object') {
      Object.keys(item).forEach((classNames) =&gt; {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

export default function addClasses() {
  const swiper = this;
  const { classNames, params, rtl, $el, device, support } = swiper;
  // prettier-ignore
  const suffixes = prepareClasses([
    'initialized',
    params.direction,
    { 'pointer-events': !support.touch },
    { 'free-mode': swiper.params.freeMode &amp;&amp; params.freeMode.enabled },
    { 'autoheight': params.autoHeight },
    { 'rtl': rtl },
    { 'grid': params.grid &amp;&amp; params.grid.rows &gt; 1 },
    { 'grid-column': params.grid &amp;&amp; params.grid.rows &gt; 1 &amp;&amp; params.grid.fill === 'column' },
    { 'android': device.android },
    { 'ios': device.ios },
    { 'css-mode': params.cssMode },
    { 'centered': params.cssMode &amp;&amp; params.centeredSlides },
    { 'watch-progress': params.watchSlidesProgress },
  ], params.containerModifierClass);
  classNames.push(...suffixes);
  $el.addClass([...classNames].join(' '));
  swiper.emitContainerClasses();
}
